import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ArrowRightCircleIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ArrowRightCircleIcon = ({ className, ...props }: ArrowRightCircleIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 12H16M16 12L12.5 8.5M16 12L12.5 15.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default ArrowRightCircleIcon;
